import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { ToastContainer } from 'react-toastify'
//import './assets/icons/tabler-icons/tabler-icons.css'
import '../node_modules/@fortawesome/fontawesome-free/css/all.min.css'
import '../node_modules/@fortawesome/fontawesome-free/css/fontawesome.min.css'
import './styles.css'
import 'react-toastify/dist/ReactToastify.css'

const container = document.getElementById('root')
const el1: HTMLElement = container as HTMLElement
const root = createRoot(el1) // createRoot(container!) if you use TypeScript
root.render(
  <React.StrictMode>
    <App />
    <ToastContainer />
  </React.StrictMode>,
)
